import { render } from "./Edit.vue?vue&type=template&id=cbea18b0&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=cbea18b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cbea18b0"

export default script